import React from "react";

const TeacherStatBox = ({ title, value }) => (
  <div className="stat-box">
    <h2>{title}</h2>
    <p>{value}</p>
  </div>
);

export default TeacherStatBox;
